/*
 * Bundle entry point. esbuild compiles this to dist/js/app.js.
 *
 * Every component is a no-op unless its markup is on the page, so this list
 * can stay as-is for the life of the project — delete an import only when you
 * have removed the component from the template for good.
 */
import $ from "./lib/jquery.js";
import Dics from "dics/src/dics.js";

import initCountUp from "./components/count-up.js";
import initForms from "./components/form.js";
import initFormSlider from "./components/form-slider.js";
import initGalleryFader from "./components/gallery-fader.js";
import initGoogleMap from "./components/google-map.js";
import initInteractiveMap from "./components/interactive-map.js";
import initRecaptcha from "./components/recaptcha.js";
import initScroller from "./components/scroller.js";
import initStaticMaps from "./components/static-map.js";

import { clickNav } from "./lib/click-nav.js";
import { alignContent, backToTop, baselineAlign, equalHeights, scrollToAnchor } from "./lib/dom.js";

/*
 * Layout helpers that page-level inline scripts still call by name.
 * Reach for CSS grid or flexbox first — these are for the awkward cases.
 */
Object.assign(window, { alignContent, backToTop, baselineAlign, equalHeights, scrollToAnchor });

function init() {
  initRecaptcha();
  initForms();
  initCountUp();
  initFormSlider();
  initGalleryFader();
  initInteractiveMap();
  initStaticMaps();
  initGoogleMap();
  initScroller();

  /*
   * Before/after comparison. Dics is bundled, not on window, so it has to be
   * initialised here rather than from an inline script in the template.
   */
  document.querySelectorAll(".b-dics").forEach((container) => {
    if (container.querySelectorAll("img").length < 2) return;
    new Dics({ container });
  });

  /*
   * sliders() before animation(), deliberately. slick's `infinite` mode
   * clones slides to fill the loop, and those clones are copies of markup
   * that carries `data-aos` (component-text-block.php puts it on its
   * wrapper). AOS collects [data-aos] once, inside AOS.init(), so anything
   * cloned after that is never in its store, never gets `.aos-animate`, and
   * stays at the opacity: 0 aos.css sets on it — the image renders and the
   * text block is invisible. Building the sliders first means the clones
   * already exist when AOS goes looking.
   */
  animation();
  sliders();
  menu();

  document.querySelectorAll(".scroller").forEach((el) => {
    el.addEventListener("click", () => scrollToAnchor(el.dataset.scrollpos));
  });
}

/*
 * Wait for ready, never run on the spot. header.php loads this bundle with
 * `defer`, so by the time it executes readyState is already "interactive" —
 * running immediately would beat any deferred script that comes after it in
 * header.php, and a jQuery plugin loaded that way would not be registered yet.
 * Deferred scripts all run before DOMContentLoaded, so waiting for it is what
 * makes the ordering in header.php mean what it looks like it means.
 */
$(init);

function animation(){


    // Animate on scroll init
    AOS.init({
      duration: 1000, // values from 0 to 3000, with step 50ms
      once: true, // whether animation should happen only once - while scrolling down
      mirror: true, // whether elements should animate out while scrolling past them
      // disable: 'mobile',
    });

    /*
     * refreshHard, not refresh: refresh() only recalculates offsets against
     * the elements AOS already knows about, so it cannot pick up markup that
     * appeared after init (slick clones, anything injected later). This is
     * the belt to the ordering above's braces.
     */
    setTimeout(function() {
        AOS.refreshHard();
    }, 500);
}

$(window).on('resize orientationchange', function() {
  if($('.carousel-location').length){
    $('.carousel-location').slick('resize');
  }
  if($('.slider-fade-center-mode-mob').length){
    $('.slider-fade-center-mode-mob').slick('resize');
  }
  if($('.slider-bedrooms').length){
    $('.slider-bedrooms').slick('resize');
  }
});

/*
 * Click-to-navigate for slick sliders with no arrows: a click on the left
 * half goes to the previous slide, the right half to the next. The gesture
 * itself lives in src/js/lib/click-nav.js, shared with the .scroller-track
 * in components/scroller.js. Call either after .slick():
 *
 *   slickClickNav($('.carousel-location'));      // with the arrow cursor
 *   slickClickNavPlain($('.slider-fade'));       // cursor left as it is
 *
 * A mouse drag still swipes as normal: slick swallows the click that ends a
 * drag before it bubbles up to here.
 */
function slickClickNav($slider){
  bindSlickClickNav($slider, true);
}

function slickClickNavPlain($slider){
  bindSlickClickNav($slider, false);
}

/*
 * One clickNav per matched element, not one for the whole selection: a
 * selector can match several sliders on a page, and each must measure its
 * own halves and move only itself.
 *
 * canGo checks slick is actually running. A slider with `settings: "unslick"`
 * at a breakpoint (.slider-bedrooms on desktop) is plain markup there, and
 * calling slickNext on it would throw — so it falls back to a normal cursor
 * and ignores clicks until the breakpoint brings slick back.
 */
function bindSlickClickNav($slider, cursor){
  $slider.each(function(){
    const $one = $(this);

    clickNav(this, {
      cursor,
      onPrev: () => $one.slick('slickPrev'),
      onNext: () => $one.slick('slickNext'),
      canGo: () => $one.hasClass('slick-initialized'),
    });
  });
}

/*
 * Autoplay options shared by every autoplaying slider, so the speed and
 * pause behaviour are set in one place. Spread into the slick() options:
 *
 *   $('.slider-fade').slick({ ...SLICK_AUTOPLAY, fade: true, … });
 *
 * pauseOnFocus is off because slick gives every slide but the current one
 * tabindex="-1", which makes them focusable by mouse. Clicking one (easy now
 * that click-to-navigate invites it, and centre-mode sliders show several
 * slides) focuses it, and slick then pauses autoplay until focus lands
 * somewhere else — so the slider looks broken until you click the page.
 *
 * pauseOnHover stays at slick's default (on): the slider holds still while
 * the pointer is over it, so a click-to-navigate lands on the slide the
 * visitor was looking at. It resumes as soon as the pointer leaves.
 */
const SLICK_AUTOPLAY = {
  autoplay: true,
  autoplaySpeed: 3000,
  pauseOnFocus: false,
  pauseOnHover: false // disabled
};

/*
 * Works around a slick 1.8.1 bug that stops autoplay for good on touch
 * screens. Any touch on the slider sets slick's internal `interrupted` flag,
 * and swipeEnd is meant to clear it — but when the finger moved vertically
 * (the visitor was scrolling the page and happened to start on the
 * slider) swipeEnd returns early and never does. Full-width sliders get
 * touched like this constantly, so after the first page scroll they stop.
 *
 * Clears the flag once the touch is over. The setTimeout lets slick's own
 * touchend handler (on the inner .slick-list) run first. `this.slick` is the
 * instance slick stores on the element; if a breakpoint has unslicked it,
 * there is nothing to fix.
 *
 * Call it after .slick() on any autoplaying slider.
 */
function slickTouchAutoplayFix($slider){
  $slider.each(function(){
    const resume = () => setTimeout(() => {
      if (this.slick) this.slick.interrupted = false;
    }, 0);

    this.addEventListener('touchend', resume, { passive: true });
    this.addEventListener('touchcancel', resume, { passive: true });
  });
}

function sliders(){
  if($('.carousel-location').length){
    $('.carousel-location').slick({
        variableWidth: true,
        arrows: false,
        dots: false
    });

    slickClickNav($('.carousel-location'));
  }
  if($('.carousel-omaya').length){
    $('.carousel-omaya').slick({
        ...SLICK_AUTOPLAY,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: false,
        mobileFirst: true,
        centerMode: true,
        centerPadding: '40px',
        responsive: [
            {
                breakpoint: 992,
                settings: {
                    centerPadding: '120px',
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    arrows: false,
                    dots: false,
                }
            }
        ]
    });

    slickClickNav($('.carousel-omaya'));
    slickTouchAutoplayFix($('.carousel-omaya'));
  }
  if($('.carousel-squillace').length){
    $('.carousel-squillace').slick({
        ...SLICK_AUTOPLAY,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: false,
        mobileFirst: true,
        centerMode: true,
        responsive: [
            {
                breakpoint: 992,
                settings: {
                    centerPadding: '25vw',
                }
            }
        ]
    });

    slickClickNav($('.carousel-squillace'));
    slickTouchAutoplayFix($('.carousel-squillace'));
  }
  if($('.slider-bedrooms').length){
    $('.slider-bedrooms').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: false,
        mobileFirst: true,
        centerMode: true,
        centerPadding: '25px',
        responsive: [
            {
                breakpoint: 992,
                settings: "unslick"
            }
        ]
    });

    slickClickNavPlain($('.slider-bedrooms'));
  }
  if($('.slider-fade-center-mode-mob').length){
    $('.slider-fade-center-mode-mob').slick({
        ...SLICK_AUTOPLAY,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: false,
        mobileFirst: true,
        centerMode: true,
        centerPadding: '25px',
        responsive: [
            {
                breakpoint: 992,
                settings: {
                  centerMode: false,
                  fade: true,
                  cssEase: 'linear'                  
                }
            }
        ]
    });

    slickClickNavPlain($('.slider-fade-center-mode-mob'));
    slickTouchAutoplayFix($('.slider-fade-center-mode-mob'));
  }
  if($('.slider-fade').length){
    $('.slider-fade').slick({
      ...SLICK_AUTOPLAY,
      fade: true,
      cssEase: 'linear',
      arrows: false,
      dots: false,
    });

    slickClickNavPlain($('.slider-fade'));
    slickTouchAutoplayFix($('.slider-fade'));
  }
}

function menu(){
  const nav = document.querySelector(".nav-menu");
  if (!nav) return;

  /*
   * Every page: .toggle-menu opens and closes .menu-panel. The panel's
   * visibility hangs off body.menu-active (see inc.menu.php), and the nav
   * sits above the panel, so the same button closes it.
   */
  $('.toggle-menu').on('click', function(){
      $('body').toggleClass('menu-active');

      $('.hamburger.toggle-menu').toggleClass('is-active');
  });

  /*
   * Home only: the nav sits transparent over the hero and fills in once the
   * page scrolls. Every other page gets bg-green-dark from inc.menu.php, so
   * this bails out there. The fade itself is the transition-colors on the
   * element — this only flips the class, at most once per frame.
   */
  if (!document.body.classList.contains("home")) return;

  let ticking = false;
  const update = () => {
    nav.classList.toggle("bg-green-dark", window.scrollY > window.innerHeight * 0.5);
    ticking = false;
  };

  window.addEventListener("scroll", () => {
    if (!ticking) {
      ticking = true;
      requestAnimationFrame(update);
    }
  }, { passive: true });

  // A reload mid-page restores the scroll position without firing scroll.
  update();
}
